// Dados canônicos extraídos da planilha analise_oficina_COM_MATRIZ.xlsx

export const SEED_PRAZOS_MODELO = [
  {
    "modelo": "Berloque",
    "prazo_prometido": 6,
    "prazo_medio": 3.65,
    "prazo_sugerido": 6,
    "fator_risco": 0.479,
    "ativo": true
  },
  {
    "modelo": "Pingente",
    "prazo_prometido": 6,
    "prazo_medio": 3.65,
    "prazo_sugerido": 6,
    "fator_risco": 0.475,
    "ativo": true
  },
  {
    "modelo": "Alianca",
    "prazo_prometido": 6,
    "prazo_medio": 4.67,
    "prazo_sugerido": 6,
    "fator_risco": 0.561,
    "ativo": true
  },
  {
    "modelo": "Triunfo",
    "prazo_prometido": 9,
    "prazo_medio": 3.79,
    "prazo_sugerido": 7,
    "fator_risco": 0.679,
    "ativo": true
  },
  {
    "modelo": "Escapulario",
    "prazo_prometido": 5,
    "prazo_medio": 3.65,
    "prazo_sugerido": 5,
    "fator_risco": 0.429,
    "ativo": true
  },
  {
    "modelo": "Atlas",
    "prazo_prometido": 7,
    "prazo_medio": 4.24,
    "prazo_sugerido": 7,
    "fator_risco": 0.647,
    "ativo": true
  },
  {
    "modelo": "Orvalia",
    "prazo_prometido": 6,
    "prazo_medio": 3.8,
    "prazo_sugerido": 6,
    "fator_risco": 0.519,
    "ativo": true
  },
  {
    "modelo": "Vitoria",
    "prazo_prometido": 6,
    "prazo_medio": 3.69,
    "prazo_sugerido": 6,
    "fator_risco": 0.532,
    "ativo": true
  },
  {
    "modelo": "Lianora",
    "prazo_prometido": 6,
    "prazo_medio": 3.78,
    "prazo_sugerido": 6,
    "fator_risco": 0.51,
    "ativo": true
  },
  {
    "modelo": "Navete",
    "prazo_prometido": 6,
    "prazo_medio": 3.8,
    "prazo_sugerido": 6,
    "fator_risco": 0.542,
    "ativo": true
  },
  {
    "modelo": "Anel",
    "prazo_prometido": 8,
    "prazo_medio": 3.65,
    "prazo_sugerido": 8,
    "fator_risco": 0.699,
    "ativo": true
  },
  {
    "modelo": "Bela",
    "prazo_prometido": 6,
    "prazo_medio": 3.79,
    "prazo_sugerido": 6,
    "fator_risco": 0.477,
    "ativo": true
  },
  {
    "modelo": "Vega",
    "prazo_prometido": 7,
    "prazo_medio": 3.76,
    "prazo_sugerido": 7,
    "fator_risco": 0.701,
    "ativo": true
  },
  {
    "modelo": "Redondo",
    "prazo_prometido": 5,
    "prazo_medio": 3.75,
    "prazo_sugerido": 5,
    "fator_risco": 0.538,
    "ativo": true
  },
  {
    "modelo": "Donna",
    "prazo_prometido": 7,
    "prazo_medio": 4.68,
    "prazo_sugerido": 7,
    "fator_risco": 0.765,
    "ativo": true
  },
  {
    "modelo": "Medalha",
    "prazo_prometido": 6,
    "prazo_medio": 3.63,
    "prazo_sugerido": 6,
    "fator_risco": 0.316,
    "ativo": true
  },
  {
    "modelo": "Aurora",
    "prazo_prometido": 7,
    "prazo_medio": 4.68,
    "prazo_sugerido": 7,
    "fator_risco": 0.622,
    "ativo": true
  },
  {
    "modelo": "Oval",
    "prazo_prometido": 7,
    "prazo_medio": 4.68,
    "prazo_sugerido": 7,
    "fator_risco": 0.595,
    "ativo": true
  },
  {
    "modelo": "Gota",
    "prazo_prometido": 6,
    "prazo_medio": 4.21,
    "prazo_sugerido": 6,
    "fator_risco": 0.559,
    "ativo": true
  },
  {
    "modelo": "Octogonal",
    "prazo_prometido": 6,
    "prazo_medio": 3.81,
    "prazo_sugerido": 6,
    "fator_risco": 0.576,
    "ativo": true
  },
  {
    "modelo": "Mimir",
    "prazo_prometido": 8,
    "prazo_medio": 4.21,
    "prazo_sugerido": 8,
    "fator_risco": 0.885,
    "ativo": true
  },
  {
    "modelo": "Corrente",
    "prazo_prometido": 1,
    "prazo_medio": 0.59,
    "prazo_sugerido": 1,
    "fator_risco": 0.0,
    "ativo": true
  },
  {
    "modelo": "Pulseira",
    "prazo_prometido": 4,
    "prazo_medio": 2.33,
    "prazo_sugerido": 4,
    "fator_risco": 0.0,
    "ativo": true
  },
  {
    "modelo": "Brinco",
    "prazo_prometido": 1,
    "prazo_medio": 0.73,
    "prazo_sugerido": 1,
    "fator_risco": 0.0,
    "ativo": true
  }
];

export const SEED_TEMPOS_ETAPA = [
  {
    "modelo": "Berloque",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.6,
    "n_amostras": 384
  },
  {
    "modelo": "Pingente",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.59,
    "n_amostras": 281
  },
  {
    "modelo": "Alianca",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.67,
    "n_amostras": 190
  },
  {
    "modelo": "Triunfo",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.77,
    "n_amostras": 179
  },
  {
    "modelo": "Atlas",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 5.65,
    "n_amostras": 152
  },
  {
    "modelo": "Escapulario",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 3.68,
    "n_amostras": 151
  },
  {
    "modelo": "Orvalia",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.69,
    "n_amostras": 113
  },
  {
    "modelo": "Vitoria",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.65,
    "n_amostras": 97
  },
  {
    "modelo": "Lianora",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.73,
    "n_amostras": 87
  },
  {
    "modelo": "Vega",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.86,
    "n_amostras": 77
  },
  {
    "modelo": "Bela",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.67,
    "n_amostras": 77
  },
  {
    "modelo": "Navete",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.69,
    "n_amostras": 75
  },
  {
    "modelo": "Anel",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.69,
    "n_amostras": 67
  },
  {
    "modelo": "Redondo",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.66,
    "n_amostras": 56
  },
  {
    "modelo": "Donna",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 5.7,
    "n_amostras": 40
  },
  {
    "modelo": "Medalha",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 3.65,
    "n_amostras": 31
  },
  {
    "modelo": "Gota",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.23,
    "n_amostras": 30
  },
  {
    "modelo": "Oval",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.74,
    "n_amostras": 30
  },
  {
    "modelo": "Aurora",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.73,
    "n_amostras": 30
  },
  {
    "modelo": "Octogonal",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 4.69,
    "n_amostras": 29
  },
  {
    "modelo": "Mimir",
    "etapa": "SOLICITACAO",
    "dias_ate_conclusao": 6.69,
    "n_amostras": 21
  },
  {
    "modelo": "Berloque",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 5.7,
    "n_amostras": 52
  },
  {
    "modelo": "Pingente",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 2.64,
    "n_amostras": 9
  },
  {
    "modelo": "Alianca",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 1.04,
    "n_amostras": 5
  },
  {
    "modelo": "Triunfo",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 1.4,
    "n_amostras": 4
  },
  {
    "modelo": "Atlas",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 0.74,
    "n_amostras": 4
  },
  {
    "modelo": "Orvalia",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 2.04,
    "n_amostras": 2
  },
  {
    "modelo": "Lianora",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 5.57,
    "n_amostras": 1
  },
  {
    "modelo": "Vega",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 0.15,
    "n_amostras": 4
  },
  {
    "modelo": "Navete",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 9.99,
    "n_amostras": 1
  },
  {
    "modelo": "Anel",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 12.79,
    "n_amostras": 2
  },
  {
    "modelo": "Redondo",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 0.22,
    "n_amostras": 3
  },
  {
    "modelo": "Donna",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 2.18,
    "n_amostras": 1
  },
  {
    "modelo": "Medalha",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 6.49,
    "n_amostras": 1
  },
  {
    "modelo": "Oval",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 0.18,
    "n_amostras": 1
  },
  {
    "modelo": "Aurora",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 5.76,
    "n_amostras": 1
  },
  {
    "modelo": "Mimir",
    "etapa": "MODELAGEM",
    "dias_ate_conclusao": 9.3,
    "n_amostras": 2
  },
  {
    "modelo": "Berloque",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.39,
    "n_amostras": 388
  },
  {
    "modelo": "Pingente",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.45,
    "n_amostras": 283
  },
  {
    "modelo": "Alianca",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.82,
    "n_amostras": 198
  },
  {
    "modelo": "Triunfo",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.8,
    "n_amostras": 187
  },
  {
    "modelo": "Atlas",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 4.54,
    "n_amostras": 162
  },
  {
    "modelo": "Escapulario",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.49,
    "n_amostras": 146
  },
  {
    "modelo": "Orvalia",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.66,
    "n_amostras": 115
  },
  {
    "modelo": "Vitoria",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.69,
    "n_amostras": 96
  },
  {
    "modelo": "Lianora",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.66,
    "n_amostras": 91
  },
  {
    "modelo": "Vega",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 4.07,
    "n_amostras": 80
  },
  {
    "modelo": "Bela",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.57,
    "n_amostras": 79
  },
  {
    "modelo": "Navete",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.63,
    "n_amostras": 80
  },
  {
    "modelo": "Anel",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 4.28,
    "n_amostras": 68
  },
  {
    "modelo": "Redondo",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.56,
    "n_amostras": 58
  },
  {
    "modelo": "Donna",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 4.19,
    "n_amostras": 43
  },
  {
    "modelo": "Medalha",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 2.68,
    "n_amostras": 31
  },
  {
    "modelo": "Gota",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.47,
    "n_amostras": 32
  },
  {
    "modelo": "Oval",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.72,
    "n_amostras": 31
  },
  {
    "modelo": "Aurora",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.79,
    "n_amostras": 32
  },
  {
    "modelo": "Octogonal",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 3.73,
    "n_amostras": 29
  },
  {
    "modelo": "Mimir",
    "etapa": "IMPRIMINDO",
    "dias_ate_conclusao": 5.78,
    "n_amostras": 22
  },
  {
    "modelo": "Berloque",
    "etapa": "CURA",
    "dias_ate_conclusao": 2.21,
    "n_amostras": 395
  },
  {
    "modelo": "Pingente",
    "etapa": "CURA",
    "dias_ate_conclusao": 2.99,
    "n_amostras": 283
  },
  {
    "modelo": "Alianca",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.13,
    "n_amostras": 199
  },
  {
    "modelo": "Triunfo",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.19,
    "n_amostras": 186
  },
  {
    "modelo": "Atlas",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.94,
    "n_amostras": 162
  },
  {
    "modelo": "Escapulario",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.06,
    "n_amostras": 138
  },
  {
    "modelo": "Orvalia",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.14,
    "n_amostras": 113
  },
  {
    "modelo": "Vitoria",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.09,
    "n_amostras": 97
  },
  {
    "modelo": "Lianora",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.13,
    "n_amostras": 91
  },
  {
    "modelo": "Vega",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.19,
    "n_amostras": 79
  },
  {
    "modelo": "Bela",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.12,
    "n_amostras": 79
  },
  {
    "modelo": "Navete",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.12,
    "n_amostras": 75
  },
  {
    "modelo": "Anel",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.9,
    "n_amostras": 68
  },
  {
    "modelo": "Redondo",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.1,
    "n_amostras": 58
  },
  {
    "modelo": "Donna",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.22,
    "n_amostras": 43
  },
  {
    "modelo": "Medalha",
    "etapa": "CURA",
    "dias_ate_conclusao": 2.59,
    "n_amostras": 33
  },
  {
    "modelo": "Gota",
    "etapa": "CURA",
    "dias_ate_conclusao": 2.92,
    "n_amostras": 32
  },
  {
    "modelo": "Oval",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.14,
    "n_amostras": 31
  },
  {
    "modelo": "Aurora",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.15,
    "n_amostras": 30
  },
  {
    "modelo": "Octogonal",
    "etapa": "CURA",
    "dias_ate_conclusao": 3.12,
    "n_amostras": 30
  },
  {
    "modelo": "Mimir",
    "etapa": "CURA",
    "dias_ate_conclusao": 5.11,
    "n_amostras": 22
  },
  {
    "modelo": "Berloque",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 1.81,
    "n_amostras": 371
  },
  {
    "modelo": "Pingente",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.12,
    "n_amostras": 268
  },
  {
    "modelo": "Alianca",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.8,
    "n_amostras": 190
  },
  {
    "modelo": "Triunfo",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.81,
    "n_amostras": 170
  },
  {
    "modelo": "Atlas",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.86,
    "n_amostras": 153
  },
  {
    "modelo": "Escapulario",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.1,
    "n_amostras": 131
  },
  {
    "modelo": "Orvalia",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.27,
    "n_amostras": 107
  },
  {
    "modelo": "Vitoria",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.54,
    "n_amostras": 90
  },
  {
    "modelo": "Lianora",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.41,
    "n_amostras": 88
  },
  {
    "modelo": "Vega",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.83,
    "n_amostras": 78
  },
  {
    "modelo": "Bela",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.18,
    "n_amostras": 77
  },
  {
    "modelo": "Navete",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.54,
    "n_amostras": 68
  },
  {
    "modelo": "Anel",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 3.17,
    "n_amostras": 66
  },
  {
    "modelo": "Redondo",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.16,
    "n_amostras": 53
  },
  {
    "modelo": "Donna",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.83,
    "n_amostras": 42
  },
  {
    "modelo": "Medalha",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.11,
    "n_amostras": 29
  },
  {
    "modelo": "Gota",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.54,
    "n_amostras": 31
  },
  {
    "modelo": "Oval",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.24,
    "n_amostras": 30
  },
  {
    "modelo": "Aurora",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.85,
    "n_amostras": 27
  },
  {
    "modelo": "Octogonal",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 2.27,
    "n_amostras": 30
  },
  {
    "modelo": "Mimir",
    "etapa": "FUNDICAO",
    "dias_ate_conclusao": 4.09,
    "n_amostras": 22
  },
  {
    "modelo": "Berloque",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.08,
    "n_amostras": 396
  },
  {
    "modelo": "Pingente",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.2,
    "n_amostras": 295
  },
  {
    "modelo": "Alianca",
    "etapa": "BANCA",
    "dias_ate_conclusao": 2.07,
    "n_amostras": 204
  },
  {
    "modelo": "Triunfo",
    "etapa": "BANCA",
    "dias_ate_conclusao": 2.1,
    "n_amostras": 189
  },
  {
    "modelo": "Atlas",
    "etapa": "BANCA",
    "dias_ate_conclusao": 2.07,
    "n_amostras": 163
  },
  {
    "modelo": "Escapulario",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.69,
    "n_amostras": 135
  },
  {
    "modelo": "Orvalia",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.92,
    "n_amostras": 116
  },
  {
    "modelo": "Vitoria",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.85,
    "n_amostras": 99
  },
  {
    "modelo": "Lianora",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.92,
    "n_amostras": 89
  },
  {
    "modelo": "Vega",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.96,
    "n_amostras": 80
  },
  {
    "modelo": "Bela",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.83,
    "n_amostras": 80
  },
  {
    "modelo": "Navete",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.96,
    "n_amostras": 81
  },
  {
    "modelo": "Anel",
    "etapa": "BANCA",
    "dias_ate_conclusao": 2.1,
    "n_amostras": 67
  },
  {
    "modelo": "Redondo",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.58,
    "n_amostras": 58
  },
  {
    "modelo": "Donna",
    "etapa": "BANCA",
    "dias_ate_conclusao": 2.12,
    "n_amostras": 43
  },
  {
    "modelo": "Medalha",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.1,
    "n_amostras": 32
  },
  {
    "modelo": "Gota",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.65,
    "n_amostras": 32
  },
  {
    "modelo": "Oval",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.98,
    "n_amostras": 31
  },
  {
    "modelo": "Aurora",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.9,
    "n_amostras": 32
  },
  {
    "modelo": "Octogonal",
    "etapa": "BANCA",
    "dias_ate_conclusao": 1.65,
    "n_amostras": 30
  },
  {
    "modelo": "Mimir",
    "etapa": "BANCA",
    "dias_ate_conclusao": 2.14,
    "n_amostras": 21
  },
  {
    "modelo": "Berloque",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.86,
    "n_amostras": 409
  },
  {
    "modelo": "Pingente",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.87,
    "n_amostras": 296
  },
  {
    "modelo": "Alianca",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.97,
    "n_amostras": 222
  },
  {
    "modelo": "Triunfo",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.93,
    "n_amostras": 191
  },
  {
    "modelo": "Atlas",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.91,
    "n_amostras": 168
  },
  {
    "modelo": "Escapulario",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.94,
    "n_amostras": 170
  },
  {
    "modelo": "Orvalia",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.88,
    "n_amostras": 120
  },
  {
    "modelo": "Vitoria",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.81,
    "n_amostras": 101
  },
  {
    "modelo": "Lianora",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.89,
    "n_amostras": 94
  },
  {
    "modelo": "Vega",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.88,
    "n_amostras": 82
  },
  {
    "modelo": "Bela",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.89,
    "n_amostras": 81
  },
  {
    "modelo": "Navete",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.92,
    "n_amostras": 83
  },
  {
    "modelo": "Anel",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.86,
    "n_amostras": 69
  },
  {
    "modelo": "Redondo",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.89,
    "n_amostras": 60
  },
  {
    "modelo": "Donna",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.9,
    "n_amostras": 44
  },
  {
    "modelo": "Medalha",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.87,
    "n_amostras": 32
  },
  {
    "modelo": "Gota",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.89,
    "n_amostras": 32
  },
  {
    "modelo": "Oval",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.87,
    "n_amostras": 33
  },
  {
    "modelo": "Aurora",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.94,
    "n_amostras": 33
  },
  {
    "modelo": "Octogonal",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.9,
    "n_amostras": 30
  },
  {
    "modelo": "Mimir",
    "etapa": "POLIMENTO",
    "dias_ate_conclusao": 0.88,
    "n_amostras": 21
  },
  {
    "modelo": "Berloque",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.07,
    "n_amostras": 0
  },
  {
    "modelo": "Pingente",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.09,
    "n_amostras": 0
  },
  {
    "modelo": "Alianca",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.18,
    "n_amostras": 0
  },
  {
    "modelo": "Triunfo",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.2,
    "n_amostras": 0
  },
  {
    "modelo": "Atlas",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.14,
    "n_amostras": 0
  },
  {
    "modelo": "Escapulario",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.09,
    "n_amostras": 0
  },
  {
    "modelo": "Orvalia",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.13,
    "n_amostras": 0
  },
  {
    "modelo": "Vitoria",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.05,
    "n_amostras": 0
  },
  {
    "modelo": "Lianora",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.17,
    "n_amostras": 0
  },
  {
    "modelo": "Vega",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.17,
    "n_amostras": 0
  },
  {
    "modelo": "Bela",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.2,
    "n_amostras": 0
  },
  {
    "modelo": "Navete",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.17,
    "n_amostras": 0
  },
  {
    "modelo": "Anel",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.12,
    "n_amostras": 0
  },
  {
    "modelo": "Redondo",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.17,
    "n_amostras": 0
  },
  {
    "modelo": "Donna",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.17,
    "n_amostras": 0
  },
  {
    "modelo": "Medalha",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.05,
    "n_amostras": 0
  },
  {
    "modelo": "Gota",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.18,
    "n_amostras": 0
  },
  {
    "modelo": "Oval",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.13,
    "n_amostras": 0
  },
  {
    "modelo": "Aurora",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.13,
    "n_amostras": 0
  },
  {
    "modelo": "Octogonal",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.19,
    "n_amostras": 0
  },
  {
    "modelo": "Mimir",
    "etapa": "RESINA_FINALIZACAO",
    "dias_ate_conclusao": 0.15,
    "n_amostras": 0
  }
];
